export default __webpack_public_path__ + "files/2817c45eff9560e7cd515e9bf878e2d0.png";